// apps/vendor/src/pages/settings/KycPage.tsx
//
// Standalone KYC verification surface for the vendor portal. Wraps the
// self-contained <StepKYCDocs> uploader (4 doc slots → POST
// /api/v1/vendor/kyc/documents) so vendors can submit identity/business docs
// outside the onboarding wizard. Uploaded docs land in `kyc_documents` and
// surface in the admin KYC queue (/vendors/kyc) for approve/reject; once all
// required docs are approved the vendor rolls up to kyc_approved=true.
//
// dbg 2026-07-15 — the uploader existed (StepKYCDocs) but was never routed, so
// vendors had no way to submit KYC. This page makes it reachable.

import { StepKYCDocs } from '../../features/onboarding/steps/StepKYCDocs.js';

export function KycPage(): JSX.Element {
  return (
    <div className="mx-auto w-full max-w-2xl px-4 py-6 sm:px-6" data-testid="vendor-kyc-page">
      <StepKYCDocs />
    </div>
  );
}

export default KycPage;
